<div class="finance-list-page">
    <app-page-shell>
        <p-toast position="top-center"></p-toast>
        <p-progressBar mode="indeterminate" *ngIf="isLoading"></p-progressBar>

        <app-page-hero eyebrow="Payables" title="Vendor Bills"
            subtitle="Review generated bills and create vouchers using the existing vendor bill workflow.">
            <div actions>
                <p-button *ngIf="canEditBill && !isConsolidatedReadOnly" label="Non-PO Draft" icon="pi pi-plus"
                    severity="secondary" [outlined]="true" (click)="createNonPoDraft()"></p-button>
                <p-button *ngIf="canGenerateVoucher && !isConsolidatedReadOnly" label="Generate Voucher" icon="fa-solid fa-file-invoice-dollar"
                    severity="help" (click)="generateVoucher()" [disabled]="!selectedBills.length"></p-button>
                <p-button label="Export" icon="pi pi-file-excel" severity="secondary" [outlined]="true"
                    (click)="exportToExcel()"></p-button>
            </div>
        </app-page-hero>

        <app-page-metric-strip [metrics]="metrics"></app-page-metric-strip>

        <app-page-search-panel title="Search bills" [activeFilters]="activeFilterCount"
            [resultText]="resultText" [collapsed]="true" (search)="applyFilters()" (clear)="clearFilters()">
            <div class="finance-search-grid">
                <app-company-scope-selector (scopeChange)="onScopeChange($event)"></app-company-scope-selector>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-users"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-multiSelect inputId="client" [options]="clients" [(ngModel)]="selectedClients"
                                optionLabel="name" display="chip" [showClear]="true" styleClass="w-full"></p-multiSelect>
                            <label for="client">Vendors</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-calendar"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-datePicker inputId="dateRange" [(ngModel)]="dateRange" selectionMode="range"
                                [readonlyInput]="true" dateFormat="yy-mm-dd" appendTo="body"
                                styleClass="w-full"></p-datePicker>
                            <label for="dateRange">Bill Date Range</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-tag"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-multiSelect inputId="status" [options]="statuses" [(ngModel)]="selectedStatuses"
                                display="chip" [showClear]="true" styleClass="w-full"></p-multiSelect>
                            <label for="status">Status</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-check-circle"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-multiSelect inputId="documentStatus" [options]="documentStatuses" [(ngModel)]="selectedDocumentStatuses"
                                display="chip" [showClear]="true" styleClass="w-full"></p-multiSelect>
                            <label for="documentStatus">Document Status</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-sitemap"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-multiSelect inputId="workflowStatus" [options]="workflowStatuses" [(ngModel)]="selectedWorkflowStatuses"
                                display="chip" [showClear]="true" styleClass="w-full"></p-multiSelect>
                            <label for="workflowStatus">Workflow Status</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-book"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-multiSelect inputId="postingStatus" [options]="postingStatuses" [(ngModel)]="selectedPostingStatuses"
                                display="chip" [showClear]="true" styleClass="w-full"></p-multiSelect>
                            <label for="postingStatus">Posting Status</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-clock"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-select inputId="dueStatus" [options]="dueStatusOptions" [(ngModel)]="selectedDueStatus"
                                [showClear]="true" styleClass="w-full"></p-select>
                            <label for="dueStatus">Due Status</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-check-square"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-multiSelect inputId="matchStatus" [options]="matchStatusOptions" [(ngModel)]="selectedMatchStatuses"
                                display="chip" [showClear]="true" styleClass="w-full"></p-multiSelect>
                            <label for="matchStatus">Match Status</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-pause"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-select inputId="paymentHold" [options]="paymentHoldOptions" [(ngModel)]="selectedPaymentHold"
                                [showClear]="true" styleClass="w-full"></p-select>
                            <label for="paymentHold">Payment Hold</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-hashtag"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <input id="vendorInvoiceNumber" type="text" pInputText [(ngModel)]="vendorInvoiceNumberFilter" />
                            <label for="vendorInvoiceNumber">Vendor Invoice #</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-dollar"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <input id="currencyCode" type="text" pInputText [(ngModel)]="currencyCodeFilter" />
                            <label for="currencyCode">Currency</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-sort-amount-up"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-inputNumber inputId="amountMin" [(ngModel)]="amountMinFilter" mode="decimal" [minFractionDigits]="2"
                                styleClass="w-full"></p-inputNumber>
                            <label for="amountMin">Amount Min</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-sort-amount-down"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <p-inputNumber inputId="amountMax" [(ngModel)]="amountMaxFilter" mode="decimal" [minFractionDigits]="2"
                                styleClass="w-full"></p-inputNumber>
                            <label for="amountMax">Amount Max</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>

                <div class="field">
                    <p-inputGroup>
                        <p-inputGroupAddon><i class="pi pi-file"></i></p-inputGroupAddon>
                        <p-iftalabel>
                            <input id="billNumber" type="text" pInputText [(ngModel)]="billNumberFilter" />
                            <label for="billNumber">Bill #</label>
                        </p-iftalabel>
                    </p-inputGroup>
                </div>
            </div>
        </app-page-search-panel>

        <app-page-data-panel title="Bill directory"
            subtitle="Backend-backed payment, workflow, posting, match, and hold states for vendor bill control."
            [resultText]="resultText">
            <div actions>
                <p-button label="Export" icon="pi pi-file-excel" severity="secondary" [outlined]="true"
                    (click)="exportToExcel()"></p-button>
            </div>

            <div class="bulk-action-bar" *ngIf="selectedBills.length && !isConsolidatedReadOnly">
                <div>
                    <strong>{{ selectedBills.length }}</strong> selected,
                    <strong>{{ formatMoney(getSelectedTotal()) }}</strong>
                </div>
                <div class="bulk-actions">
                    <p-button *ngIf="canGenerateVoucher" label="Generate Voucher" icon="fa-solid fa-file-invoice-dollar"
                        severity="help" (click)="generateVoucher()" [disabled]="!selectedBills.length"></p-button>
                </div>
            </div>

            <app-accounting-directory-controls documentType="BILL" [filters]="directoryFilters"
                [searchText]="searchText" [selectedStatuses]="selectedDocumentStatuses" [pendingStatuses]="pendingStatuses" (searchTextChange)="onDirectorySearch($event)"
                (modeChange)="onDirectoryModeChange($event)" (pending)="showPendingStatuses()"
                (all)="showAllStatuses()"></app-accounting-directory-controls>
            <p-table *ngIf="directoryMode === 'LIST'" class="finance-table" [value]="allBills" dataKey="billId" [paginator]="true"
                [rows]="rows" [first]="first" [showCurrentPageReport]="true" [totalRecords]="totalRecords"
                [lazy]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                (onLazyLoad)="loadData($event)" [rowsPerPageOptions]="[20, 50, 100]"
                [(selection)]="selectedBills" [tableStyle]="{ 'min-width': '0' }">
                <ng-template pTemplate="header">
                    <tr>
                        <th *ngIf="!isConsolidatedReadOnly" style="width: 3.5rem"><p-tableHeaderCheckbox></p-tableHeaderCheckbox></th>
                        <th>Bill</th>
                        <th>Vendor</th>
                        <th>Amounts</th>
                        <th>Approval/Payment Status</th>
                        <th>Due/Match Details</th>
                        <th>Actions</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-bill>
                    <tr>
                        <td *ngIf="!isConsolidatedReadOnly" data-label="Select"><p-tableCheckbox [value]="bill"></p-tableCheckbox></td>
                        <td data-label="Bill">
                            <div class="stack-cell">
                                <span class="cell-title">{{ bill.billNumber || 'No bill number' }}</span>
                                <span class="cell-meta" *ngFor="let deliveryNumber of getDeliveryNumbers(bill)">{{ deliveryNumber }}</span>
                                <div class="cell-meta">
                                    <span class="code-pill">ID {{ bill.billId || '-' }}</span>
                                    <span>{{ bill.billType || 'STANDARD' }}</span>
                                </div>
                            </div>
                        </td>
                        <td data-label="Vendor">
                            <div class="stack-cell">
                                <span class="cell-title">{{ crmPartyContext.displayName(bill) }}</span>
                                <div class="cell-meta">Contact: {{ crmPartyContext.contactDisplayName(bill) }}</div>
                            </div>
                        </td>
                        <td data-label="Amounts">
                            <div class="amount-block">
                                <span class="amount-primary">{{ bill.totalAmount | currency:bill.country?.currencyCode:(bill.country?.currencyCode || 'SAR') + ' ' }}</span>
                                <span class="amount-secondary">{{ 'accountingAmounts.beforeTax' | transloco }} {{ getBeforeTaxAmount(bill) != null ? (getBeforeTaxAmount(bill) | currency:bill.country?.currencyCode:(bill.country?.currencyCode || 'SAR') + ' ') : '—' }}</span>
                                <span class="amount-secondary">Open {{ getOpenAmount(bill) | currency:bill.country?.currencyCode:(bill.country?.currencyCode || 'SAR') + ' ' }}</span>
                                <span class="amount-secondary">Tax {{ bill.taxAmount | currency:bill.country?.currencyCode:(bill.country?.currencyCode || 'SAR') + ' ' }}</span>
                            </div>
                        </td>
                        <td data-label="Approval/Payment Status">
                            <div class="status-stack">
                                <p-tag [severity]="statusSeverity(bill.documentStatus)" [value]="bill.documentStatus || 'UNKNOWN'"></p-tag>
                                <p-tag [severity]="statusSeverity(bill.status)" [value]="bill.status || 'UNKNOWN'"></p-tag>
                                <span class="muted-pill">{{ bill.postingStatus || 'NOT_POSTED' }}</span>
                                <span class="muted-pill" *ngIf="bill.paymentHold">Payment hold</span>
                            </div>
                        </td>
                        <td data-label="Due/Match Details">
                            <div class="stack-cell">
                                <span class="cell-title">{{ bill.dueDate | date:'yyyy-MM-dd' }}</span>
                                <div class="cell-meta vertical">
                                    <span>Bill date {{ bill.billDate | date:'yyyy-MM-dd' }}</span>
                                    <span>{{ bill.matchStatus || 'MATCH_NOT_REQUIRED' }}</span>
                                    <span>{{ bill.vouchers?.length || 0 }} vouchers linked</span>
                                </div>
                            </div>
                        </td>
                        <td data-label="Actions">
                            <div class="row-actions">
                                <p-button icon="pi pi-eye" [rounded]="true" [text]="true" pTooltip="View bill"
                                    (click)="viewBill(bill)"></p-button>
                                <p-button *ngIf="canEditDraftBill(bill)" icon="pi pi-pencil" [rounded]="true" [text]="true"
                                    severity="secondary" pTooltip="Edit draft" (click)="editBill(bill)"></p-button>
                                <p-button icon="pi pi-list" [rounded]="true" [text]="true" pTooltip="Preview lines"
                                    (click)="openPreview(bill)"></p-button>
                                <p-button *ngIf="canPostBill(bill)" icon="pi pi-check-circle" [rounded]="true" [text]="true"
                                    severity="success" pTooltip="Post Bill" (click)="postBill(bill)"></p-button>
                                <app-finance-pdf-view-button kind="vendor-bill" [documentId]="bill.billId" [documentReference]="bill.billNumber" [postingStatus]="bill.postingStatus" [iconOnly]="true" [disabled]="documentActions.isPending(bill.billId)"></app-finance-pdf-view-button>
                                <p-button [icon]="bill.postingStatus === 'POSTED' ? 'pi pi-download' : 'pi pi-print'" [rounded]="true" [text]="true" severity="info" [loading]="documentActions.isPending(bill.billId)"
                                    [pTooltip]="bill.postingStatus === 'POSTED' ? 'Download Bill' : 'Print / reprint draft from latest saved changes'" (click)="downloadBill(bill)"></p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7">
                            <div class="empty-state">
                                <i class="pi pi-inbox"></i>
                                <strong>No bills match these filters</strong>
                                <span>Clear filters or refresh the list to view generated bills.</span>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </app-page-data-panel>
    </app-page-shell>

    <p-drawer [(visible)]="isPreviewVisible" position="right" styleClass="finance-preview-drawer">
        <ng-template pTemplate="header">
            <div class="stack-cell">
                <strong>{{ previewBill?.billNumber || 'Bill lines' }}</strong>
                <span class="cell-meta">{{ previewBill?.billLines?.length || 0 }} lines</span>
            </div>
        </ng-template>
        <div class="preview-list" *ngIf="previewBill?.billLines?.length; else noBillLines">
            <div class="preview-line" *ngFor="let line of previewBill?.billLines">
                <div class="preview-line-header">
                    <div>
                        <div class="preview-line-title">{{ line.itemNumber || line.itemDescription || 'Line item' }}</div>
                        <div class="cell-meta">{{ line.headerReferenceNumber }} / {{ line.detailReferenceNumber }}</div>
                    </div>
                    <div class="preview-line-amount">{{ formatMoney(line.chargeAmount, previewBill?.country?.currencyCode) }}</div>
                </div>
            </div>
        </div>
        <ng-template #noBillLines>
            <div class="preview-empty">No bill lines available.</div>
        </ng-template>
    </p-drawer>
</div>
